<template>
  <div
    class="stats-card"
    :style="{ '--card-color': color }"
  >
    <div class="stats-card__content">
      <div class="stats-card__label">{{ label }}</div>
      <div class="stats-card__value">{{ value }}</div>
    </div>
    <div class="stats-card__icon">
      <q-icon :name="icon" size="sm" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatsCard',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#3182ce'
    }
  }
};
</script>

<style lang="scss" scoped>
.stats-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-radius: 12px;
  background: white;
  border: 1px solid #e2e8f0;
  border-left: 4px solid var(--card-color);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.05), 0 2px 2px rgba(0, 0, 0, 0.05);

  &:hover {
    background: var(--card-color);
    border-color: var(--card-color);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);

    .stats-card__label, .stats-card__value {
      color: white;
    }

    .stats-card__icon {
      background: rgba(255, 255, 255, 0.2);
      color: white;
    }
  }

  &__content {
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #718096;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 4px;
    transition: color 0.3s ease;
  }

  &__value {
    font-size: 1.5rem;
    font-weight: 800;
    line-height: 1;
    color: var(--card-color);
    transition: color 0.3s ease;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: color-mix(in srgb, var(--card-color), transparent 90%);
    color: var(--card-color);
    transition: all 0.3s ease;
  }
}
</style>
